import { FaCheck } from 'react-icons/fa';
import style from './thank-you.module.scss';
import cx from 'classnames';
import { HTMLAttributes, PropsWithChildren, useEffect } from 'react';
import { useAuthContext } from '../../../context/AuthContext/AuthContext';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { CgArrowLongLeft as PreviousIcon } from 'react-icons/cg';
import { useCartContext } from '../../../context/CartContext/CartContext';

interface ThankYouProps extends HTMLAttributes<HTMLDivElement> {
  setNoSideBar: (value: boolean | ((value: boolean) => boolean)) => void;
}

export default function ThankYou({
  setNoSideBar,
  ...props
}: PropsWithChildren<ThankYouProps>) {
  //setNoSideBar(true); TREBALO BI DA SE RESETUJE KAD ODE BILO GDE DRUGDE
  const { user, dispatch } = useAuthContext();
  const { cartClear } = useCartContext();

  useEffect(() => {
    cartClear();
  }, []);

  return (
    <div {...props} className={cx(style.wrapper, 'cs-content no-sidebar')}>
      <div className={style.icon}>
        <FaCheck />
      </div>
      <h1>Hvala na porudžbini{user?.name ? `, ${user.name}` : ''}!</h1>
      <p>
        Vaša porudžbina je uspešno poslata. Očekujte odgovor na{' '}
        <span>{user?.email}</span> u najkraćem mogućem roku.
        <br />
        Naš tim će pregledati vašu porudžbinu i kontaktirati vas sa detaljima.
      </p>
      <ButtonPrimary url={'/'}>
        <PreviousIcon className={style.buttonIcon} />
        Povratak u prodavnicu
      </ButtonPrimary>
    </div>
  );
}
